'use strict';

angular.module('AcaApp').controller('UserPhoneController', [
  '$scope',
  '$window',
  '$location',
  '$rootScope',
  'SettingsService',
  'UserService',
  'AuthenticationService',
  'ManagedUserInformationService',
  '$mdDialog',
  function($scope, $window, $location, $rootScope, SettingsService, UserService, AuthenticationService, ManagedUserInformationService, $mdDialog){
    $scope.newPhone = '';
    $scope.errorMessage = '';
    $scope.showNextButton = true;
    $scope.showMainReturnToLoginButton = false;

    $scope.showFlatReturnToLoginButton = function(){
      return ($window.sessionStorage.MFAEnabled === 'Y' && !$scope.showMainReturnToLoginButton);
    };

    $scope.resetErrorMessage = function(){
      $scope.errorMessage = '';
    };

    $scope.validatePhone = function(){
      return /^(\d{3})[-]?(\d{3})[-]?(\d{4})$/.test($scope.newPhone);
    };

    $scope.phoneAdded = function(data){
      if(data.result.value){
        $window.sessionStorage.phoneNumber = $scope.newPhone.replace(/-/g, '').slice(-4);
        $scope.updateMFA('Y');
      }
      else {
        $scope.errorMessage = 'There was an issue trying to save your phone number.';
      }
    };

    $scope.updatePhone = function(){
      if($scope.validatePhone()){
        $scope.errorMessage = '';
        if($window.sessionStorage.MFAToken){
          AuthenticationService.updatePhoneWithToken($window.sessionStorage.MFAToken, '+1'+$scope.newPhone.replace(/-/g, ''))
          .then(function(data){
            if(data.result.value){
              $window.sessionStorage.phoneNumber = $scope.newPhone.replace(/-/g, '').slice(-4);
              $window.sessionStorage.fromAddPhone = true;
              $location.path('/send-mfa');
            }
            else {
              $scope.errorMessage = 'There was an issue trying to save your phone number.';
            }
          })
          .catch(function(error){
            if (error.data.error.frontend_code && error.data.error.frontend_code === 'EXPIRED_PHONETOKEN'){
              $scope.errorMessage = error.data.error.frontend_message;
              $scope.showNextButton = false;
              $scope.showMainReturnToLoginButton = true;
            }
            else {
              $scope.errorMessage = 'There was an issue trying to save your phone number.';
            }
          });
        }else{
          UserService.updatePhone($window.sessionStorage.userId, '+1'+$scope.newPhone.replace(/-/g, ''), true)
          .then($scope.phoneAdded)
          .catch(function(){
            $scope.errorMessage = 'There was a problem trying to process your request. Please verify that phone number is correct.';
          });
        }
      }
      else {
        $scope.errorMessage = 'Please enter a valid 10 digit phone number.';
      }
    };

    $scope.isCancelAvailable = function(){
      return ($window.sessionStorage.profile === 'CNV_ACAADMIN' && $window.sessionStorage.MFAEnabled === 'null');
    };

    $scope.cancel = function(){
      $mdDialog.show({
        scope: $scope.$new(),
        templateUrl: '/app/views/mfa/modals/cancel_mfa_activation.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true
      });
    };

    $scope.closeDialog = function(){
      $mdDialog.hide();
    };

    $scope.updateMFA = function(option){
      SettingsService.updateMfa(option).then(function(data){
        if(data.result.value === 'updated'){
          $rootScope.userVerified = true;
          $mdDialog.hide();
          $window.sessionStorage.MFAEnabled = option;
          if (option === 'Y'){
            $window.sessionStorage.fromAddPhone = true;
            $location.path('/send-mfa');
          }
          else {
            ManagedUserInformationService.findClient();
            $window.sessionStorage.secondsLeft = $window.sessionStorage.sessionExpireSetting;
            AuthenticationService.setSessionInterval();
            
            SettingsService.getTaxYears().then(function(data){
              $window.localStorage['TaxYears'] = data.result.value;
              $window.localStorage['FirstTimeTaxYears'] = true;
              $scope.taxYears = $window.localStorage['TaxYears'].split(',');
            });

            if($window.sessionStorage.eulaAccepted === 'false'){
              $location.path('/license-agreement');
            }
            else{
              $location.path('/home');
              AuthenticationService.checkEmailToApprove();
            }
          }
        }
        else {
          $scope.errorMessage = 'There was an issue trying to deactivating multi-factor authentication.';
        }
      });
    };

    $scope.returnToLogin = function(){
      $location.search({});
      AuthenticationService.logout();
    };
  }
]);